/* ========================================================================== *\
    Imports
/* ========================================================================== */
import { keys, forEach, filter, findIndex, isElement } from 'lodash';

import { publish } from '../2-utilities/event';
import { store } from '../2-utilities/store';

import { queryAncestor } from '../2-utilities/dom';
import { isDesktop, isMobile } from '../2-utilities/breakpoint';

import {
    MARKERS_CHANGED as markersChanged,
    START_AUTOPLAY as startAutoplay,
    STOP_AUTOPLAY as stopAutoplay,
    QUIT_AUTOPLAY as quitAutoplay,
    STOP_MARKERS_POPUP as stopMarkersPopup,
    MARKERS_PLACED as markersPlaced,
    MARKER_SELECTED as markerSelected,
    MARKER_DESELECTED as markerDeselected
} from '../3-data/consts/eventNames';

import interpolateColors from '../4-features/interpolateColors';

/* ========================================================================== *\
    Constants
/* ========================================================================== */
const classNames = {
    base: 'c-marker js-marker',
    size: {
        K: '--small',
        M: '--medium',
        G: '--big'
    }
},
    { ranking } = store,
    // iconHtml = `
    // <svg width="28px" height="28px" viewBox="0 0 28 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    //     <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    //         <g id="Group-8" transform="translate(8.615385, 7.179487)">
    //             <path d="M0,13.6410256 L10.7692308,13.6410256 L10.7692308,0 L0,0 L0,13.6410256 Z M7.452782,7.81006673 L9.95026909,7.81006673 L9.95026909,6.10596126 L7.452782,6.10596126 L7.452782,7.81006673 Z M4.13587184,7.81006673 L6.63335893,7.81006673 L6.63335893,6.10596126 L4.13587184,6.10596126 L4.13587184,7.81006673 Z M0.818961682,7.81006673 L3.31691016,7.81006673 L3.31691016,6.10596126 L0.818961682,6.10596126 L0.818961682,7.81006673 Z M7.452782,10.3223609 L9.95026909,10.3223609 L9.95026909,8.6178009 L7.452782,8.6178009 L7.452782,10.3223609 Z M4.13587184,10.3223609 L6.63335893,10.3223609 L6.63335893,8.6178009 L4.13587184,8.6178009 L4.13587184,10.3223609 Z M0.818961682,10.3223609 L3.31691016,10.3223609 L3.31691016,8.6178009 L0.818961682,8.6178009 L0.818961682,10.3223609 Z M7.452782,12.833746 L9.95026909,12.833746 L9.95026909,11.129186 L7.452782,11.129186 L7.452782,12.833746 Z M4.13587184,12.833746 L6.63335893,12.833746 L6.63335893,11.129186 L4.13587184,11.129186 L4.13587184,12.833746 Z M0.818961682,12.833746 L3.31691016,12.833746 L3.31691016,11.129186 L0.818961682,11.129186 L0.818961682,12.833746 Z" id="Fill-1" fill="#FFFFFF"></path>
    //             <polygon id="Fill-2" fill="#ED1A3B" points="8.61538462 2.00024613 7.3330872 2.00024613 7.3330872 0.717948718 6.30793844 0.717948718 6.30793844 2.00024613 5.02564103 2.00024613 5.02564103 3.02582563 6.30793844 3.02582563 6.30793844 4.30769231 7.3330872 4.30769231 7.3330872 3.02582563 8.61538462 3.02582563"></polygon>
    //         </g>
    //     </g>
    // </svg>
    // `,
    // iconHTML2 = `
    // <svg class="marker-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.77 13.64">
    //     <path d="M0,13.64H10.77V0H0Zm3.32-.81H.82v-1.7h2.5Zm3.31,0H4.14v-1.7H6.63Zm3.32,0H7.45v-1.7H10Zm0-2.51H7.45V8.62H10Zm0-2.51H7.45V6.11H10ZM5,2H6.31V.72h1V2H8.62V3H7.33V4.31h-1V3H5ZM4.14,6.11H6.63v1.7H4.14ZM6.63,8.62v1.7H4.14V8.62ZM.82,6.11h2.5v1.7H.82Zm2.5,2.51v1.7H.82V8.62Z"/>
    // </svg>
    // `,
    // iconHTML3 = `
    // <svg class="marker-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.7 20.8">
    //     <path d="M13.5,4V1h-6v3h-5v2h6c1.1,0,2,0.9,2,2h-8v2h6c1.1,0,2,0.9,2,2h-8v2h5.9c1,0,2.1,0.9,2.1,2h-8v2h18V4H13.5z M18.5,10h-2v2h-2v-2h-2V8h2V6h2v2h2V10z"/>
    // </svg>
    // `;
    iconHTML3 = `
    <svg class="marker-icon" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
        <polygon id="Fill-1" points="0 0 0 5 2 5 2 30 12 30 12 20 18 20 18 30 28 30 28 5 30 5 30 0"></polygon>
        <polygon id="Fill-2" fill="#FFFFFF" points="4.5 25 9.5 25 9.5 20 4.5 20"></polygon>
        <polygon id="Fill-3" fill="#FFFFFF" points="20.5 25 25.5 25 25.5 20 20.5 20"></polygon>
        <polygon id="Fill-4" fill="#FFFFFF" points="22 7.30769231 22 12.6923077 17.5 12.6923077 17.5 17 12.5 17 12.5 12.6923077 8 12.6923077 8 7.30769231 12.5 7.30769231 12.5 3 17.5 3 17.5 7.30769231"></polygon>
    </svg>
    `;

const ANIMATION_SPEED = 3.5;

/* ========================================================================== *\
    Custom marker class
/* ========================================================================== */
function CustomMarker(list, item, color, i, year, map) {
    this.type = getType(list, item);
    this.list = ranking;
    this.item = item;
    this.color = color;
    this.i = i;
    this.year = year;
}

function getType(list, item) {
    const { Ranking } = item;

    let type = 'default';

    if (Ranking <= 10) {
        type = 'top';
    }
    if (Ranking > (list.length - 10)) {
        type = 'bottom';
    }

    return type;
}

function getScore(score) {
    let number = score.replace(',', '.'),
        rankingScore = parseFloat(number);

    if (!rankingScore) {
        rankingScore = 0;
    }

    if (rankingScore < 5.5) {
        return 'bad';
    }

    if (rankingScore >= 5.5 && rankingScore < 6.5) {
        return 'average';
    }

    if (rankingScore >= 6.5 && rankingScore < 8) {
        return 'oke';
    }

    if (rankingScore >= 8) {
        return 'good';
    }

    return 'oke';
}

function getPopupScore(ranking, type, color) {
    if (ranking === 0) {
        return '';
    }

    return `<div class="c-popup__score c-popup__score--${type}" style="background-color: rgba(${color[0]}, ${color[1]}, ${color[2]})">${ranking}</div>`;
}

function getPopupHtml(item, type, color) {
    return `
        <div class="c-popup">
            ${getPopupScore(item.Ranking, type, color)}
            <div class="c-popup__content">
                <div class="c-popup__name">${item.Ziekenhuis}</div>
                <div class="c-popup__city">${item.Plaats}</div>
            </div>
        </div>
    `;
}

function getAllItems(list, name) {
    const keyList = keys(list);

    let items = [],
        obj = {};

    forEach(keyList, key => {
        const item = filter(
            list[key],
            {
                Ziekenhuis: name
            }
        );

        obj[key] = item;

        items.push(obj);
    });

    return items;
}

function getIndexPerYear(list, name) {
    const keyList = keys(list);

    let items = [],
        obj = {};

    forEach(keyList, key => {
        const index = findIndex(
            list[key],
            {
                Ziekenhuis: name
            }
        );

        obj[key] = index;

        items.push(obj);
    });

    return items;
}

function getItemType(list, item) {
    const { Ranking } = item;

    let type = 'default';

    if (Ranking <= 10) {
        type = 'top';
    }
    if (Ranking > (list.length - 10)) {
        type = 'bottom';
    }

    return type;
}

function drawSvg(coords) {
    let svg = '<svg height="100%" width="100%">';

    forEach(coords, (coord, i) => {
        const nextCoord = coords[i + 1];

        if (nextCoord) {
            const delay = (i + .5) / ANIMATION_SPEED;
            svg += `
                <line x1="${coord[0]}" y1="${coord[1]}" x2="${nextCoord[0]}" y2="${nextCoord[1]}" style="animation-delay: ${delay}s" />
            `;
        }
    })

    svg += '</svg>'

    return svg;
}

function getPositionGraph(items, index, list, year) {
    const keyList = keys(items[0]),
        coords = [];

    let frag = '<div class="c-graph__container">',
        colors = {};

    forEach(keyList, key => {
        // if the first item Ranking !== 1 the list is reversed
        colors[key] = interpolateColors(list[key].length, list[key][0].Ranking !== 1);
    });

    const multiplier = isMobile() ? document.body.clientWidth / 11.5 : 38;

    const width = keyList.length * multiplier;
    const step = width / keyList.length;

    forEach(keyList, (key, i) => {
        const item = items[0][key][0];
        let color = colors[key][index[0][key]];

        if (!item || item.Ranking === 0) {
            coords.push([
                i * step + 10,
                103
            ]);

            frag += `
                <div class="c-graph__item">
                    <div class="c-graph__year">${key.slice(-2)}</div>
                </div>
            `;
        } else {
            let top = item.Ranking * 100 / 81,
                type = getItemType(list[key], item);

            coords.push([
                i * step + 10,
                top
            ]);

            const delay = i / ANIMATION_SPEED;

            frag += `
                <div class="c-graph__item">
                    <div class="c-graph__score c-graph__score--${type}" style="top: ${top}px; background-color: rgb(${color[0]}, ${color[1]}, ${color[2]}); animation-delay: ${delay}s;">
                        <div class="c-graph__heading"></div>
                        <div class="c-graph__cijfer">${item.Ranking}</div>
                    </div>
                    <div class="c-graph__year">${key.slice(-2)}</div>
                </div>
            `;
        }
    });

    frag += '</div>';

    frag += drawSvg(coords);

    return frag;
}

function getScoreGraph(items, list) {
    const keyList = keys(items[0]),
        coords = [];

    let frag = '<div class="c-graph__container">';

    const multiplier = isMobile() ? document.body.clientWidth / 11.5 : 38;

    const width = keyList.length * multiplier;
    const step = width / keyList.length;

    forEach(keyList, (key, i) => {
        const item = items[0][key][0];

        if (!item || item.Ranking === 0) {
            coords.push([
                i * step + 10,
                103
            ]);

            frag += `
                <div class="c-graph__item">
                    <div class="c-graph__year">${key.slice(-2)}</div>
                </div>
            `;
        } else {
            let score = parseFloat(item.Rapportcijfer.replace(/,/g, '.'));

            if (!score) {
                score = 0;
            }

            let additionTop = (score === 0) ? 1 : score,
                top = 100 - (10 * additionTop) + 10,
                type = 'top',
                left = i * step + 10;

            if (score < 5.5) {
                type = 'bottom';
            }

            if (score === 0) {
                type = 'default';
            }

            coords.push([
                left,
                top
            ]);

            const delay = i / ANIMATION_SPEED;

            frag += `
                <div class="c-graph__item">
                    <div class="c-graph__score c-graph__score--score c-graph__score--${type}" style="top: ${top}px; animation-delay: ${delay}s;">
                        <div class="c-graph__heading"></div>
                        <div class="c-graph__cijfer">${score === 0 ? '-' : score}</div>
                    </div>
                    <div class="c-graph__year">${key.slice(-2)}</div>
                </div>
            `;
        }
    });

    frag += '</div>'

    frag += drawSvg(coords);

    return frag;
}

function getNumbers(item) {
    let string = '';

    if (item.Solvabiliteit) {
        const number = Number(item.Solvabiliteit).toFixed(2);

        string += `
            <div class="c-numbers__item">
                <div class="c-numbers__title">Solvabiliteit</div>
                <div class="c-numbers__value">${number.replace('.', ',')}%</div>
            </div>
        `;
    }

    if (item.CurrentRatio) {
        const number = Number(item.CurrentRatio).toFixed(2);

        string += `
            <div class="c-numbers__item">
                <div class="c-numbers__title">Current ratio</div>
                <div class="c-numbers__value">${number.replace('.', ',')}</div>
            </div>
        `;
    }

    if (item.Rendement) {
        const number = Number(item.Rendement).toFixed(2);

        string += `
            <div class="c-numbers__item">
                <div class="c-numbers__title">Rendement</div>
                <div class="c-numbers__value">${number.replace('.', ',')}%</div>
            </div>
        `;
    }

    if (item.EBITDAOpbrengsten) {
        const number = Number(item.EBITDAOpbrengsten).toFixed(2);

        string += `
            <div class="c-numbers__item">
                <div class="c-numbers__title">EBITDA / opbrengsten</div>
                <div class="c-numbers__value">${number.replace('.', ',')}%</div>
            </div>
        `;
    }

    if (item.DSCR) {
        const number = Number(item.DSCR).toFixed(2);

        string += `
            <div class="c-numbers__item">
                <div class="c-numbers__title">DSCR <span>(Debt Service Coverage Ratio)</span></div>
                <div class="c-numbers__value">${number.replace('.', ',')}</div>
            </div>
        `;
    }

    if (!string) {
        return '';
    }


    return `
        <div class="c-numbers js-numbers-score">
            ${string}
        </div>
    `;
}

function getDetailHtmlContent(name, item, positionGraph, scoreGraph, year, numbers) {
    return `
        <div class="c-detail-popup__content">
            <div class="c-detail-popup__title">
                <div class="c-detail-popup__title-inner">
                    <div class="c-detail-popup__name">${name}</div>
                    <div class="c-detail-popup__city">${item.Plaats}</div>
                    <div class="c-detail-popup__year">${year}</div>
                </div>
            </div>
            ${numbers}
            <div class="c-detail-popup__graphs">
                <div class="c-graph c-graph--position js-graph-position --hide">
                    <div class="c-graph__middle"></div>
                    <div class="c-graph__inner">
                        ${positionGraph}
                    </div>
                </div>
                <div class="c-graph c-graph--rapport js-graph-score">
                    <div class="c-graph__middle"></div>
                    <div class="c-graph__inner">
                        ${scoreGraph}
                    </div>
                </div>
            </div>
        </div>
        <div class="c-detail-popup__controls">
            <button class="c-detail-popup__button js-graph-button --active" data-type="score">Rapportcijfer</button>
            <button class="c-detail-popup__button js-graph-button" data-type="position">Positie</button>
        </div>
    `;
}

function getDetailHtml(list, item, year) {
    const name = item.Ziekenhuis,
        allItems = getAllItems(list, name),
        indexPerYear = getIndexPerYear(list, name),
        scoreGraph = getScoreGraph(allItems, list),
        positionGraph = getPositionGraph(allItems, indexPerYear, list, year),
        numbers = getNumbers(item, year);
    const content = getDetailHtmlContent(name, item, positionGraph, scoreGraph, year, numbers);

    // <button class="c-detail-popup__close js-detail-close">Terug naar overzicht</button>

    return `
        <div class="c-detail-popup js-detail-popup --hide">
            ${content}
        </div>
    `;
}

function getDetailHtmlDialog(list, item, year) {
    const name = item.Ziekenhuis,
        allItems = getAllItems(list, name),
        indexPerYear = getIndexPerYear(list, name),
        scoreGraph = getScoreGraph(allItems, list),
        positionGraph = getPositionGraph(allItems, indexPerYear, list, year),
        numbers = getNumbers(item, year);
    return getDetailHtmlContent(name, item, positionGraph, scoreGraph, year, numbers);
}

function getHTML(list, item, type, color, year) {
    const popupHTML = getPopupHtml(item, type, color),
        detailHTML = getDetailHtml(list, item, year);

    return popupHTML + iconHTML3 + detailHTML;
}

CustomMarker.prototype = new google.maps.OverlayView();

CustomMarker.prototype.onRemove = function () {
    return;
}

CustomMarker.prototype.draw = function () {
    const self = this;

    let div = this.div;

    if (!div) {
        div = this.div = document.createElement('div');

        const sizeClass = classNames.size[this.item['Omvang_ZKH']];

        div.className = `${classNames.base} js-marker-${this.i} c-marker--${this.type} ${sizeClass} --hide`;

        document.body.addEventListener('click', (e) => {
            const popup = this.div.querySelector('.js-detail-popup');

            if (!queryAncestor(e.target, '.js-marker') && !queryAncestor(e.target, '.c-list__row') && !queryAncestor(e.target, '.js-detail-popup-dialog')) {
                popup.classList.add('--hide');
                this.div.classList.remove('--active');

                // if (self.map.getZoom() === self.map.minZoom) {
                //     self.map.setCenter({ lat: 52.084166, lng: 5.5124522 })
                //     self.map.setZoom(self.map.minZoom);
                // }

                publish(markerDeselected);
            }
        })

        google.maps.event.addDomListener(div, 'click', (event) => {
            google.maps.event.trigger(self, 'click');

            const markers = document.querySelectorAll('.js-marker'),
                popups = document.querySelectorAll('.js-detail-popup'),
                popup = this.div.querySelector('.js-detail-popup');

            if (!queryAncestor(event.target, '.js-detail-popup')) {
                self.map.setCenter(this.item.coords);
            } else {
                if (queryAncestor(event.target, '.js-detail-close')) {
                    popup.classList.add('--hide');
                    this.div.classList.remove('--active');

                    if (self.map.getZoom() === self.map.minZoom) {
                        self.map.setCenter({ lat: 52.084166, lng: 5.5124522 })
                        self.map.setZoom(self.map.minZoom);
                    }

                    publish(markerDeselected);
                }

                return;
            }

            if (this.div.classList.contains('--active')) {
                popup.classList.add('--hide');
                this.div.classList.remove('--active');

                self.map.setCenter({ lat: 52.084166, lng: 5.5124522 })
                self.map.setZoom(self.map.minZoom);

                publish(markerDeselected);
                publish(markersPlaced);

                return;
            }

            forEach(markers, marker => {
                marker.classList.remove('--active');
            })

            this.div.classList.add('--active');

            forEach(popups, item => {
                item.classList.add('--hide');
            })

            popup.classList.remove('--hide');

            publish(quitAutoplay);
            publish(stopMarkersPopup);

            const html = getDetailHtmlDialog(this.list, this.item, this.year);
            publish(markerSelected, html);
        });

        google.maps.event.addDomListener(window, 'click', (event) => {
            const popup = this.div.querySelector('.js-detail-popup');

            if (popup.classList.contains('--hide')) {
                return;
            }

            if (queryAncestor(event.target, '.js-marker') || !queryAncestor(event.target, '.js-maps')) {
                return;
            }

            if (!queryAncestor(event.target, '.js-detail-popup') && !queryAncestor(event.target, '.js-detail-popup-dialog') && !queryAncestor(event.target, '.c-list__row')) {
                popup.classList.add('--hide');
                this.div.classList.remove('--active');

                // if (self.map && self.map.getZoom() === self.map.minZoom) {
                //     self.map.setCenter({ lat: 52.084166, lng: 5.5124522 })
                //     self.map.setZoom(self.map.minZoom);
                // }

                publish(markerDeselected);
            }
        });

        google.maps.event.addDomListener(div, 'mouseover', () => {
            publish(stopAutoplay);
            publish(stopMarkersPopup);
        });

        google.maps.event.addDomListener(div, 'mouseleave', () => {
            publish(startAutoplay);

            if (!div.classList.contains('--active')) {
                publish(markersPlaced);
            }
        });

        let html = getHTML(this.list, this.item, this.type, this.color, this.year);

        const panes = this.getPanes();
        panes.overlayImage.appendChild(div);

        div.setAttribute('data-type', this.item['Omvang_ZKH']);
        div.setAttribute('data-score', getScore(this.item['Rapportcijfer']));
        div.setAttribute('data-position', this.item['Positie']);
        div.setAttribute('data-name', this.item['Ziekenhuis']);
        div.setAttribute('data-city', this.item['Plaats']);
        div.setAttribute('data-coords', JSON.stringify(this.item.coords));

        div.innerHTML = html;
        // div.style.backgroundColor = `rgb(${this.color[0]}, ${this.color[1]}, ${this.color[2]})`;
        div.querySelector('.marker-icon').style.fill = `rgb(${this.color[0]}, ${this.color[1]}, ${this.color[2]})`;

        publish(markersChanged, { selector: `.js-marker-${this.i}` });
    }

    const lat = this.item.coords.lat,
        lng = this.item.coords.lng,
        latLng = new google.maps.LatLng(lat, lng);

    const point = self
        .getProjection()
        .fromLatLngToDivPixel(latLng);

    if (point) {
        div.style.left = point.x + 'px';
        div.style.top = point.y + 'px';
    }

    bindings();
};

function toggleGraph() {
    const button = this,
        parent = queryAncestor(button, '.js-detail-popup') || queryAncestor(button, '.js-detail-popup-dialog'),
        type = button.getAttribute('data-type'),
        graphs = parent.querySelectorAll('.c-graph'),
        numbers = parent.querySelectorAll('.c-numbers'),
        buttons = parent.querySelectorAll('.js-graph-button');

    forEach(graphs, graph => {
        graph.classList.add('--hide');
    })

    forEach(buttons, btn => {
        btn.classList.remove('--active');
    })

    button.classList.add('--active');
    parent.querySelector(`.js-graph-${type}`).classList.remove('--hide');
}

function bindings() {
    const graphButtons = document.querySelectorAll('.js-graph-button');

    forEach(graphButtons, btn => {
        btn.addEventListener('click', toggleGraph);
    })
}

/* ========================================================================== *\
    Exports
\* ========================================================================== */

export default CustomMarker;